import load from '#core/load';


const root_$ = '[data-pullquote-carousel]';
const slide_$ = '[data-pullquote-carousel-slide]';
const previous_$ = '[data-pullquote-carousel-previous]';
const next_$ = '[data-pullquote-carousel-next]';
const active_attr = 'data-carousel-active';
const direction_attr = 'data-carousel-direction';
const transition_attr = 'data-carousel-transition';
const transition_done_fallback = 520;


const module = {
	init() {
		load.content(() => {
			document.querySelectorAll(root_$).forEach(init_carousel);
		});
	},
};

export default module;
module.init();


function init_carousel($root) {
	const $slides = [...$root.querySelectorAll(slide_$)];
	const $previous = $root.querySelector(previous_$);
	const $next = $root.querySelector(next_$);

	if ($slides.length < 2 || !$previous || !$next) return false;

	let active_index = Math.max($slides.findIndex($slide => !$slide.hidden), 0);

	const show_slide = index => {
		const next_index = (index + $slides.length) % $slides.length;
		if (next_index === active_index) return false;

		const direction = next_index > active_index || (active_index === $slides.length - 1 && next_index === 0)
			? 'next'
			: 'previous';
		const $active = $slides[active_index];
		const $next_slide = $slides[next_index];

		$root.setAttribute(direction_attr, direction);
		$active.setAttribute(transition_attr, 'leaving');
		$next_slide.hidden = false;
		$next_slide.setAttribute(transition_attr, 'entering');

		requestAnimationFrame(() => {
			$active.removeAttribute(active_attr);
			$next_slide.setAttribute(active_attr, 'true');
			$next_slide.removeAttribute(transition_attr);
		});

		const finish = () => {
			$active.hidden = true;
			$active.removeAttribute(transition_attr);
			$active.removeEventListener('transitionend', finish);
		};

		$active.addEventListener('transitionend', finish);
		setTimeout(finish, transition_done_fallback);
		active_index = next_index;
	};

	$previous.addEventListener('click', () => show_slide(active_index - 1));
	$next.addEventListener('click', () => show_slide(active_index + 1));
	$slides.forEach(($slide, slide_index) => {
		$slide.hidden = slide_index !== active_index;
		$slide.toggleAttribute(active_attr, slide_index === active_index);
	});
}
